/**
 * created by lei lei
 * 输入框描述组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import {Modal, Input,Tag,message} from "antd";
import Btn from "./Btn";
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../../utils";
import request from "../../../../base/request";
import moment from "moment";
import {getInfoFromLocalStorage} from "../../../../actions";

const {TextArea}=Input;

export default class InputMark extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            textAreaMark:'',
            chooseObj:[],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    sysConfigLoadOver(){
        console.log(this.props.record,'22222');
        let record=this.props.record;
        let look=false;
        let operation='edit';
        operation=this.sysConfig.operation||'edit';
        if(operation=='edit'){
            look=false
        }else{
            look=true
        }
        let requestTextAreaMarkParam=this.sysConfig.requestTextAreaMarkParam||'ask';
        let requestChooseObjParam=this.sysConfig.requestChooseObjParam||'askObject';
        if(look){
            this.setState({
                textAreaMark:record[requestTextAreaMarkParam],
                chooseObj:record[requestChooseObjParam],
            })
        }else{

        }
        if(record &&record.refuseReason) {
            this.setState({
                textAreaMark:record.refuseReason,
                // chooseObj:record.askObjectTemp,
            })
        }


    }

    customRender() {
        let mark = this.sysConfig.mark;
        let textAreaMarks = this.sysConfig.textAreaMark;
        let textAreaTitle=this.sysConfig.textAreaTitle;
        let chooseTitle=this.sysConfig.chooseTitle;
        let textAreaTitleShow = this.sysConfig.textAreaTitleShow || "" ;
        let chooseTitleShow = this.sysConfig.chooseTitleShow || "" ;
        let textAreaTitleIsRequest = this.sysConfig.textAreaTitleIsRequest || "" ;
        let chooseTitleIsRequest = this.sysConfig.chooseTitleIsRequest || "" ;

        console.log('------------35--',this.state);
        console.log('是否必填',textAreaTitleIsRequest)
        let look=false;
        let operation='edit';
        operation=this.sysConfig.operation||'edit';

        if(operation=='edit'){
            look=false
        }else{
            look=true
        }

        let btnList=this.sysConfig.chooseBtn&&this.sysConfig.chooseBtn.btnList||[];
        console.log(btnList)
        let disableTextArea = this.sysConfig.disableTextArea ||"";
        return (
            <div>
                <style>
                    {
                        `.ant-modal-header{
                            background:#F6F8FD;
                            padding:12px 24px;
                         }
                         .ant-modal-close-x {
                            width:47px;
                            height:47px;
                            line-height:47px;
                         }                        
                         `
                    }
                </style>
                {mark && <div >{mark}</div>}
                {
                    textAreaTitleShow&&<div style={{display:"flex",marginTop:20}}>
                        {textAreaTitleIsRequest?<span style={{color:"red",marginRight:8}}>*</span>:null}{textAreaTitle?<div style={{fontSize:14,minWidth:64,marginRight:17}}>{textAreaTitle} :</div>:null}
                        <TextArea disabled={disableTextArea} style={{resize:"none",background:"#F6F8FD",width:"100%",height:120}} value={this.state.textAreaMark}
                                  onChange={(e)=>{
                                      this.setState({textAreaMark:e.target.value})
                                  }}
                                  placeholder={textAreaMarks}/>
                    </div>
                }
                {
                    chooseTitleShow && <div style={{display: "flex", marginTop: 20}}>
                        {chooseTitleIsRequest ?<span style={{color: "red", marginRight: 8,}}>*</span>:null}<span style={{minWidth:64,fontSize:14,marginRight:17}}>{chooseTitle} :</span>
                        {look?null:<div style={{width:65}}>
                            <Btn btnList={btnList} float={'float'} record={this.props.record}
                                 refresh={(data) => this.getChooseUser(data)}/>
                        </div>}
                        <div style={{height: 100,width:300}}>
                            {look?<Scrollbars style={{height:100}}>
                                {
                                    this.state.chooseObj&&this.state.chooseObj.map((item, index) => {
                                        if(item){
                                            return (
                                                <Tag ky={index+'0'} style={{marginBottom:10}} >
                                                    {item||item.name}
                                                </Tag>
                                            )
                                        }

                                    })
                                }
                            </Scrollbars>: <Scrollbars style={{height:100}}>
                                {
                                    this.state.chooseObj&&this.state.chooseObj.map((item, index) => {
                                        console.log(this.state.chooseObj,item.name,index)
                                        return (
                                            <Tag ky={uuid()} visible={true} style={{marginBottom:10}} closable onClose={() => {
                                                this.tagClose(index)
                                            }}>
                                                {item.name||item}
                                            </Tag>
                                        )
                                    })
                                }
                            </Scrollbars>}
                        </div>

                        {/* <div>请选择</div>*/}
                    </div>
                }
            </div>
        )
    }

    onOk(){
        let btn2=this.sysConfig.btn2||{};
        let url=btn2.requestUrl||'';
        let body={};
        let method =btn2.requestMethod || 'get';
        // 增加自定义二次更新数据，在一次确定按钮之后继续调用另一个接口
        let upDate = this.sysConfig.upDate ||"";
        let record = this.props.record;
        let expression = this.sysConfig.expression ||"";
        if(url){
            let customRequestId = btn2.customRequestId || '';
            if(customRequestId&&this.props.record){
                url=url+this.props.record.id;
            }
            //封装参数
            let textAreaTitleIsRequest = this.sysConfig.textAreaTitleIsRequest || "" ;
            let chooseTitleIsRequest = this.sysConfig.chooseTitleIsRequest || "" ;
            let textAreaTitle=this.sysConfig.textAreaTitle;
            let messageContent=this.sysConfig.messageContent;

            let chooseTitle=this.sysConfig.chooseTitle;
            let approvalReasonKey = btn2.approvalReasonKey || '';
            let CurrentUserKey =  btn2.CurrentUserKey || '';
            let account = window.top.currentUser.account;

            if(CurrentUserKey){
                body[CurrentUserKey] =  account; //审批意见
            }
            if (approvalReasonKey) {
                if(textAreaTitleIsRequest&!this.state.textAreaMark.length){
                    message.info('请填写'+messageContent)
                    return
                }
                body[approvalReasonKey] = this.state.textAreaMark; //审批意见
            }

            let requestTextAreaMarkParam = this.sysConfig.requestTextAreaMarkParam || '';
            let textAreaMarks = this.sysConfig.textAreaMark;

            if (requestTextAreaMarkParam) {
                if(textAreaTitleIsRequest&&!this.state.textAreaMark.length){
                    message.info(textAreaMarks)
                    return
                }
                body[requestTextAreaMarkParam] = this.state.textAreaMark;
            }

            let requestChooseObjParam = btn2.requestChooseObjParam || '';
            let requestChooseObjValKey = btn2.requestChooseObjValKey || 'id';
            let chooseIds=[];
            this.state.chooseObj.forEach(item=>{
                chooseIds.push(item[requestChooseObjValKey])
            });
            if (requestChooseObjParam) {
                if(chooseTitleIsRequest&!chooseIds.length){
                    message.info('请选择'+chooseTitle)
                    return
                }
                body[requestChooseObjParam] = chooseIds;
            }

            let customRequestParam = btn2.customRequestParam || '';
            let customRequestValue = btn2.customRequestValue || '';
            if (customRequestParam||customRequestValue) {
                body[customRequestParam] = customRequestValue;
            }
            let customRequestParamTime = btn2.customRequestParamTime || '';
            if (customRequestParamTime) {
                body[customRequestParamTime] = moment().valueOf();//毫秒数
            }
            let customRequestParamUser = btn2.customRequestParamUser || '';
            let approvalIdKey = btn2.approvalIdKey || '';
            let approvalTimeKey = btn2.approvalTimeKey || '';

            let id = getInfoFromLocalStorage("currentUser").id||'';
            if (customRequestParamUser) {
                body[customRequestParamUser] = id;//账户
            }
            if (approvalIdKey) { //审批人
                body[approvalIdKey] = id;
            }
            if (approvalTimeKey) { //审批时间
                body[approvalTimeKey] = new Date().getTime();
            }

            request({
                url:url,
                method,
                contentType:'json',
                body: body,
                callBack: (data) => {
                    if(upDate) {
                        this.upDateStatus()
                    }
                    if(eval(expression)) { //当主线索 设置状态时更新到子线索
                        this.updateMultiStatus();
                    }

                    this.complete();
                }
            });
        }else{
            this.complete();
        }
    }
    updateMultiStatus() {
        let body = {};
        let params = [];
        let {

            requestUrl="/cm-sites-bus/bd/xgdNewsClue/updateMulti",
            requestMethod="post",
            contentType="json",
            updateKey="businessData",
            updateVal = {
                "status": 2
            },
            requestCustomParam = {
                "key":"mainClueId","opt":"eq","val":""
            },
            requestStatusParam=null
        } = this.sysConfig.updateStatusRequest;
        let  record = this.props.record ||"";

        body[updateKey] = updateVal;
        requestCustomParam.val = record && record.id && record.id;
        requestStatusParam&& params.push(requestStatusParam) ;

        params.push(requestCustomParam) ;
        body.params = params;
        this.request({
            url:requestUrl,
            contentType:contentType,
            method:requestMethod,
            body,
            callback:(dada)=>{
                this.complete();
            }
        })


    }

    upDateStatus() {
        let body = {};
        let { requestMethod="post",
            requestUrl="/cm-sites-bus/bd/xgdNewsClue/update",
            contentType="json",
            requestStatusParam="status",
            requestStatusParamVal =4
        } = this.sysConfig.upDate;
        let  record = this.props.record ||"";
        if(record.id) {
            requestUrl +="/"+record.id
        }
        body[requestStatusParam] = requestStatusParamVal
        this.request({
            url:requestUrl,
            contentType:contentType,
            method:requestMethod,
            body,
            callback:(dada)=>{

            }
        })


    }


    getChooseUser(list){
        let checkId=this.sysConfig.checkId||'_id';
        list.forEach(itemCheck=>{
            let  num=0;
            this.state.chooseObj.forEach(item=>{
                if(itemCheck[checkId]!==item[checkId]){
                    num++;
                }
            });
            if(num===this.state.chooseObj.length){
                this.state.chooseObj.push(itemCheck)
            }
        });
        console.log(this.state.chooseObj);
        this.setState({});
    }

    tagClose(index){
        this.state.chooseObj.splice(index,1);
        console.log(this.state.chooseObj);
        this.setState({})
    }


}